import i18next from "i18next";
import { z } from "zod";
import { FIELD_REQUIRED } from "../../../../i18n/keysTranslations";

const isMissingValue = (issue) =>
  issue.code === z.ZodIssueCode.invalid_type &&
  (issue.received === "null" || issue.received === "undefined");

const isEmptyRequiredString = (issue) =>
  issue.code === z.ZodIssueCode.too_small &&
  issue.type === "string" &&
  Number(issue.minimum) === 1;

// Platform schemas call i18next.t() at import time, before i18n is ready, so
// the custom message is dropped and zod falls back to English ("Required",
// "String must contain at least 1 character(s)"). Translate when validating.
export const campaignFormErrorMap = (issue, ctx) => {
  if (isMissingValue(issue) || isEmptyRequiredString(issue)) {
    return { message: i18next.t(FIELD_REQUIRED) };
  }

  return { message: ctx.defaultError };
};

export const CAMPAIGN_FORM_ZOD_PARAMS = {
  errorMap: campaignFormErrorMap,
};
